function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8097f;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Recurso 2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M174.35,208H33.65A33.64,33.64,0,0,1,0,174.35V33.65A33.64,33.64,0,0,1,33.65,0h140.7A33.64,33.64,0,0,1,208,33.65v140.7A33.64,33.64,0,0,1,174.35,208Zm31-36.35V36.35A33.66,33.66,0,0,0,171.65,2.7H36.35A33.66,33.66,0,0,0,2.7,36.35v135.3A33.66,33.66,0,0,0,36.35,205.3h135.3A33.66,33.66,0,0,0,205.3,171.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M136.57,44.76c-.42,0-.84-.07-1.27-.07H37.43a11.78,11.78,0,0,0,0,23.56H69.87l-8.42,4.42,0,76a11.78,11.78,0,0,0,23.56,0V68.25h48.4s0,0,.06.08c20,0,22.31,11.59,22.31,18.08,0,14.44-16,15.43-16,15.43H133.1l0,.06H118.27a11.79,11.79,0,0,0-11.78,11.78v8.7l0,0,0,26.23a11.78,11.78,0,0,0,23.56,0V129.47l-10.38-4h13.65c37,.74,47.44-21.82,47.44-36.67,0-40.73-34-44-44.23-44"
}))));

const SvgTodopagoLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208 208",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTodopagoLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/todopagoLogo.f61919e8.svg";
export { ForwardRef as ReactComponent };